import { render, staticRenderFns } from "./IlluSmartphoneAcadomia.vue?vue&type=template&id=de134ff2&"
import script from "./IlluSmartphoneAcadomia.vue?vue&type=script&lang=js&"
export * from "./IlluSmartphoneAcadomia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports